import { Vue, Component, Watch } from 'vue-property-decorator';
import BCardCode from '@core/components/b-card-code/BCardCode.vue';
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BButton,
  BModal,
  BForm,
  BCardText,
  BImg,
  BBadge,
  BTabs,
  BTab
} from 'bootstrap-vue';
import OrderList from '@/views/order/orderList/OrderList.vue';
import { ListVue, listVueMixin } from '@/utility/pagination/list-vue.mixin';
import { orderListDispatcher } from './orderList/store/order-list.module';
import { DEFAULT_ORDER_PAGE_SIZE } from '@/utility/pagination/pagination';
import { DropdownOption } from '@/utility/dropdowns/dropdownOptions';
import OrderForm from '@/views/order/orderForm/OrderForm.vue';
import OrderStastiticNavBar from './OrderStastiticNavBar.vue';
import { OrderListViewModel } from '@/api/api';

@Component({
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardCode,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    BModal,
    BForm,
    BCardText,
    BImg,
    BBadge,
    BTabs,
    BTab,
    OrderList,
    OrderForm,
    OrderStastiticNavBar
  },
  mixins: [
    listVueMixin({
      initialInput: {
        itemsPerPage: DEFAULT_ORDER_PAGE_SIZE,
        searchText: '',
        filterStatus: [] as DropdownOption[],
        filterPaymentStatus: [] as DropdownOption[],
        filterEmployee: ''
      },
      dispatcher: orderListDispatcher
    })
  ]
})
export default class OrderPage extends Vue {
  orderListDispatcher = orderListDispatcher;
  selectedTab = 0;
  editOrderId = 0;
  selectedOrders: OrderListViewModel[] = [];
  previousTab = 0;

  $refs!: {
    orderListRef: any;
    orderBillListRef: any;
  };

  get isDisplayOrderNavbar() {
    return this.selectedOrders.length > 0 && this.selectedTab == 0;
  }

  setSelectedOrders(values: OrderListViewModel[]) {
    this.selectedOrders = [...values];
  }

  resetTab() {
    window.scrollTo(0, 0);
    this.selectedTab = this.previousTab;
    this.editOrderId = 0;
    this.orderListDispatcher.load();
  }

  handleEditOrder(id) {
    this.previousTab = this.selectedTab;
    this.editOrderId = id;
    this.selectedTab = 1;
  }

  onUpdateStatusSuccess() {
    this.$refs.orderListRef.reloadList(this.selectedOrders.map((s) => s.id));
    this.$refs.orderBillListRef.reloadList(
      this.selectedOrders.map((s) => s.id)
    );
  }
}
